<template>
  <v-app>
    <v-system-bar class="bg-sub" fixed height="6"></v-system-bar>

    <v-app-bar class="bg-main top-6-px" dark fixed>
      <v-toolbar-title class="mt-5-px d-flex">
        <!-- <v-img src="/images/logo.png" contain height="36"></v-img> -->
        <v-btn
          text
          v-for="(item, i) in menuItems"
          :key="i"
          class="text-uppercase"
          :to="item.link"
        >
          {{ $t(item.key) }}</v-btn
        >
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <template v-for="(item, index) in langList">
        <v-btn
          v-if="item.key !== lang"
          :key="index"
          light
          small
          elevation="0"
          rounded
          plain
          @click.stop="changeLang(item)"
        >
          {{ item.text }}
        </v-btn>
      </template>
      <v-btn
        light
        small
        elevation="0"
        rounded
        plain
        text
        @click.stop="$router.push({ path: '/member' })"
      >
        {{ loginUser.pid }} {{ loginUser.loginname }}
      </v-btn>
      <v-btn
        class="mr-2"
        light
        small
        elevation="0"
        rounded
        plain
        icon
        @click.stop="ChangeDialog('Logout')"
      >
        <v-icon small>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-sheet id="container-sorce" class="pt-70-px overflow-y-auto">
      <v-container>
        <v-tabs class="mt-40-px" v-model="activeTab" vertical color="#00838F">
          <v-tab class="justify-start" v-for="item in tabList" :key="item.id">
            <v-icon left> {{ item.iconKey }} </v-icon>
            {{ $t(item.text) }}
          </v-tab>
          <v-tab-item>
            <v-card class="user-information bg-sub-rev" flat dark elevation="5">
              <v-card-subtitle>
                <span class="ml-3 lh-18-px">User Information</span>
              </v-card-subtitle>
              <v-divider></v-divider>
              <v-card-text
                class="
                  text-h5
                  font-weight-bold
                  d-flex
                  align-center
                  justify-center
                  py-60-px
                "
              >
                <v-avatar
                  class="bg-sub-rev uppercase mr-15-px white--text elevation-2"
                  color="grey darken-3"
                  size="80"
                >
                  {{ loginUser.loginname.split('')[0] }}
                </v-avatar>
                <v-card class="bg-transparent" flat>
                  <v-card-subtitle class="pa-0 pt-6-px">
                    {{ loginUser.pid }}
                  </v-card-subtitle>
                  <v-card-title class="fz-42-px uppercase lh-32-px pa-0">
                    {{ loginUser.loginname }}
                  </v-card-title>
                  <v-list-item
                    class="grow fz-14-px font-weight-light minh-24-px"
                  >
                    <v-row align="center" justify="center">
                      <template v-for="item in loginUser.roles">
                        <template>
                          <v-icon class="mr-2 fz-22-px" :key="item">
                            {{
                              item.includes('MGR-')
                                ? 'mdi-shield-account'
                                : 'mdi-card-account-details'
                            }}
                          </v-icon>
                          <span class="subheading mr-2" :key="`text- ${item}`">
                            {{ $t(item) }}
                          </span>
                        </template>
                      </template>
                    </v-row>
                  </v-list-item>
                </v-card>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions align="center" justify="center">
                <v-btn plain @click.stop="ChangeDialog('SetPassword')">
                  {{ $t('PASSWORD_CHANGE') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <template v-if="ableToModifyUser">
            <v-tab-item>
              <v-btn
                fab
                small
                elevation
                absolute
                class="left-5-px"
                @click.stop="showCreateRow = !showCreateRow"
              >
                <v-icon v-text="showCreateRow ? 'mdi-close' : 'mdi-plus'"
                  >mdi-television</v-icon
                >
              </v-btn>
              <v-card flat>
                <v-card-text class="pt-8-px pl-40-px">
                  <MemberCreate
                    :activeTab="1"
                    :headers="headers"
                    :showCreateRow="showCreateRow"
                    :apiDone="apiDone"
                    :listData="setSelectDataList(tabList[1].key)"
                    :tableTitle="tabList[1]"
                  ></MemberCreate>
                  <v-divider class="my-3"></v-divider>
                  <MemberTable
                    :apiDone="apiDone"
                    :headers="headers"
                    :tableTitle="tabList[1]"
                    :userList="userListFilted"
                  ></MemberTable>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-btn
                fab
                small
                elevation
                absolute
                class="left-5-px"
                @click.stop="switchCreateMemberArea(!showCreateRow)"
              >
                <v-icon v-text="showCreateRow ? 'mdi-close' : 'mdi-plus'"
                  >mdi-television</v-icon
                >
              </v-btn>
              <v-card flat>
                <v-card-text class="pt-8-px pl-40-px">
                  <MemberCreate
                    :activeTab="2"
                    :headers="headers"
                    :showCreateRow="showCreateRow"
                    :apiDone="apiDone"
                    :listData="setSelectDataList(tabList[2].key)"
                    :tableTitle="tabList[2]"
                  ></MemberCreate>
                  <v-divider class="my-3"></v-divider>
                  <MemberTable
                    :apiDone="apiDone"
                    :headers="headers"
                    :tableTitle="tabList[2]"
                    :userList="userListFilted"
                  ></MemberTable>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </template>
        </v-tabs>
      </v-container>
    </v-sheet>
    <Dialog></Dialog>
    <Snackbar></Snackbar>
  </v-app>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

import Dialog from '../components/Dialog.vue'
import Snackbar from '../components/Snackbar.vue'

import MemberCreate from '../components/MemberCreate.vue'
import MemberTable from '../components/MemberTable.vue'

export default {
  name: 'Member',

  inject: ['reload'],

  provide() {
    return {
      getDefaultPassword: this.getDefaultPassword,
      getUsers: this.getUsers,
      switchCreateMemberArea: this.switchCreateMemberArea
    }
  },

  components: {
    Snackbar,
    Dialog,
    MemberCreate,
    MemberTable
  },

  data() {
    return {
      showCreateRow: false,
      apiDone: true,
      activeTab: -1,
      listData: {
        rolesList: [
          { text: '用戶管理', value: 'MGR-ACTER' },
          { text: '編輯技術文檔', value: 'MGR-EDITER' },
          { text: '查看完整正式技術文檔', value: 'MGR-READER' }
        ],
        flagList: [
          { text: '停用', value: 0 },
          { text: '啟用', value: 1 }
        ],
        pidList: []
      },
      memberClass: {
        NORMAL: 'NORMAL',
        'MGR-READER': '查看技術文檔',
        'MGR-ACTER': '用戶管理',
        'MGR-EDITER': '編輯技術文檔'
      },
      headers: [
        {
          text: 'PID',
          value: 'pid',
          dataKey: 'pid',
          listKey: 'pidList',
          valueType: 'text',
          modifyType: 'autocomplete',
          isRequired: true
        },
        {
          text: '帳號名稱',
          align: 'start',
          value: 'loginname',
          dataKey: 'loginname',
          valueType: 'text',
          modifyType: 'text',
          isRequired: true
        },
        // {
        //   text: '集團',
        //   value: 'group',
        //   dataKey: 'group',
        //   valueType: 'text',
        //   modifyType: 'text',
        //   isRequired: false
        // },
        {
          text: '管理權限',
          value: 'rolesLang',
          dataKey: 'roles',
          valueType: 'checkbox',
          modifyType: 'checkbox',
          listKey: 'rolesList',
          isRequired: false
        },
        {
          text: '操作',
          dataKey: 'actions',
          value: 'actions',
          valueType: '',
          isRequired: false,
          sortable: false
        }
      ],
      userList: [],
      pidList: {
        admin: [],
        normal: []
      },
      pidAdmin: []
    }
  },

  computed: {
    ...mapState('common', ['menuItems', 'lang', 'langList']),
    ...mapState('auth', ['isLogin', 'loginUser']),
    ...mapState('member', ['editedData', 'major']),
    ableToModifyUser() {
      let res = false
      if (this.loginUser.roles.includes('MGR-ACTER')) {
        res = true
      }
      return res
    },
    tabList() {
      const list = [
        { id: 1, text: 'MEMBER_MENU_1', iconKey: 'mdi-account', key: 'self' },
        {
          id: 2,
          text: 'MEMBER_MENU_2',
          iconKey: 'mdi-card-account-details',
          key: 'normal'
        },
        {
          id: 3,
          text: 'MEMBER_MENU_3',
          iconKey: 'mdi-shield-account',
          key: 'admin'
        }
      ]
      const arr = [list[0]]

      if (this.ableToModifyUser) {
        arr.push(list[1], list[2])
      }

      return arr
    },
    userListFilted() {
      let arr = []
      switch (this.activeTab) {
        case 1:
          arr = this.userList.filter((item) => {
            return !this.pidAdmin.includes(item.pid)
          })
          break
        case 2:
          arr = this.userList.filter((item) => {
            return this.pidAdmin.includes(item.pid)
          })
          break
      }
      // console.log(arr)
      return arr
    }
  },

  watch: {
    activeTab(newVal) {
      this.showCreateRow = false
    }
  },

  mounted() {
    this.activeTab = 0
    if (this.ableToModifyUser) {
      this.getPids()
      this.getUsers()
    }
  },

  methods: {
    ...mapMutations('common', ['ChangeDialog', 'ChangeState']),
    ...mapActions('message', ['setSnackbar']),
    setSelectDataList(key) {
      const data = JSON.parse(JSON.stringify(this.listData))
      data.pidList = this.pidList[key]
      return data
    },
    switchCreateMemberArea(data) {
      this.showCreateRow = data
    },
    getPids() {
      this.pidList = {
        admin: [],
        normal: []
      }
      this.apiDone = false
      this.$api.common.prodid.getAll().then((res) => {
        this.apiDone = true
        for (const i in res) {
          const curr = res[i]
          curr.text =
            curr.pid +
            (curr.major_role !== 0
              ? ' (' + this.major[curr.major_role] + ')'
              : '')
          const typeKey = curr.admin === 1 ? 'admin' : 'normal'
          this.pidList[typeKey].push(curr)
          if (typeKey === 'admin') {
            this.pidAdmin.push(curr.pid)
          }
        }
      })
    },
    getUsers() {
      this.userList = []
      this.apiDone = false
      this.$api.common.user.getAll().then((res) => {
        this.apiDone = true
        for (const i in res) {
          const curr = res[i]
          curr.rolesArr = curr.roles.split(',')
          curr.rolesLang = ''
          for (const j in curr.rolesArr) {
            const role = curr.rolesArr[j]
            curr.rolesLang += (j !== '0' ? ', ' : '') + this.$t(role)
          }
          // if (curr.loginname !== this.loginUser.loginname) {
          this.userList.push(curr)
          // }
        }
      })
    },
    getDefaultPassword(length, ...options) {
      if (!length) {
        return false
      }

      const passArrItem = []
      const getNumber = () => Math.floor(Math.random() * 10)
      const getUpLetter = () =>
        String.fromCharCode(Math.floor(Math.random() * 26) + 65)
      const getLowLetter = () =>
        String.fromCharCode(Math.floor(Math.random() * 26) + 97)

      const passMethodArr = [getNumber, getUpLetter, getLowLetter]

      const getIndex = () => Math.floor(Math.random() * 3)
      const getPassItem = () => passMethodArr[getIndex()]()
      Array(length - 3)
        .fill('')
        .forEach(() => {
          passArrItem.push(getPassItem())
        })

      const confirmItem = [getNumber(), getUpLetter(), getLowLetter()]

      passArrItem.push(...confirmItem)
      return passArrItem.join('')
    },
    changeLang(item) {
      this.ChangeState({ key: 'lang', val: item.key })
      this.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.user-information {
  &::before {
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    //background: url('/images/logo-icon.png') repeat center center;
    background-size: 88px;
    position: absolute;
    opacity: 0.06;
  }
}
.v-toolbar__extension {
  justify-content: center !important;
}
</style>
